import React from 'react';

const Loader = () => {
    return (
        <div className="auteco_loader-container">
            <div className="loader"></div>
            <p className="loader-text">Cargando...</p>
        </div>
    );
};

export default Loader;
